import { render, staticRenderFns } from "./time_ago_tooltip.vue?vue&type=template&id=6b359461&vue3"
import script from "./time_ago_tooltip.vue?vue&type=script&lang=js&vue3"
export * from "./time_ago_tooltip.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports